export const state = {
  loading: true,
  showingUserMessage: false,
  userMessage: {
    title: '',
    message: '',
    success: false,
  },
  agencyProfile: {},
  categories: [],
  settings: {},
};
